import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: () => import('../views/Index/Index.vue')
  },
  {
    path: '/Index',
    name: 'Index',
    component: () => import('../views/Index/Index.vue')
  },
  {
    path: '/Hotspot',
    name: 'Hotspot',
    component: () => import('../views/Hotspot.vue')
  },
  {
    path: '/Notice',
    name: 'Notice',
    component: () => import('../views/Notice.vue')
  },
  {
    path: '/Register',
    name: 'Register',
    component: () => import('../views/Register.vue')
  },
  {
    path: '/Library',
    name: 'Library',
    component: () => import('../views/Library.vue')
  },
  {
    path: '/Classroom',
    name: 'Classroom',
    component: () => import('../views/Classroom.vue')
  },
  {
    path: '/Jurisdiction',
    name: 'Jurisdiction',
    component: () => import('../views/Backpage/Jurisdiction.vue')
  },
  {
    path: '/Statistics',
    name: 'Statistics',
    component: () => import('../views/Backpage/Statistics.vue')
  },
  {
    path: '/Conversion',
    name: 'Conversion',
    component: () => import('../views/Conversion.vue')
  },
  {
    path: '/Declare',
    name: 'Declare',
    component: () => import('../views/Declare/Declare.vue')
  },
  {
    path: '/entTable',
    name: 'entTable',
    component: () => import('../views/Index/entTable.vue')
  },
  {
    path: '/Elegant',
    name: 'Elegant',
    component: () => import('../views/Index/Elegant.vue')
  },
  {
    path: '/Introductory',
    name: 'Introductory',
    component: () => import('../views/Index/Introductory.vue')
  }, {
    path: '/Dynamic',
    name: 'Dynamic',
    component: () => import('../views/Index/Dynamic.vue')
  },
  {
    path: '/ContactUs',
    name: 'ContactUs',
    component: () => import('../views/ContactUs.vue')
  },
  {
    path: '/CurriculumDetails',
    name: 'CurriculumDetails',
    component: () => import('../views/CurriculumDetails.vue')
  },
  {
    path: '/MarketInformation',
    name: 'MarketInformation',
    component: () => import('../views/MarketInformation.vue')
  },
  {
    path: '/decNotice',
    name: 'decNotice',
    component: () => import('../views/Declare/decNotice'),
    meta: {
      needLogin: true
    }
  },
  {
    path: '/Surface',
    name: 'Surface',
    component: () => import('../views/Declare/Surface'),
    meta: {
      needLogin: true
    }
  },
  {
    path: '/Notice/NotDel',
    name: "NotDel",
    component: () => import('../views/NotDel.vue')
  },
  {
    path: '/Translation/:Tid',
    name: "Translation",
    component: () => import('../views/Translation')
  },
  {
    path: '/Chart',
    name: "Chart",
    component: () => import('../views/Declare/Chart.vue')
  },
  {
    path: '/Hotspot/HotDetails',
    name: 'HotDetails',
    component: () => import('../views/HotDetails.vue')
  },
  // {
  //   path: '/uploadReport',
  //   name: 'uploadReport',
  //   component: () => import('../views/Declare/uploadReport')
  // },
  {
    path: '/Announcement',
    name: 'Announcement',
    component: () => import('../views/Backpage/Announcement')
  },
  {
    path: '/Structure',
    name: 'Structure',
    component: () => import('../views/Backpage/Structure')
  },
  {
    path: '/Bgjurisdiction',
    name: 'Bgjurisdiction',
    component: () => import('../views/Backpage/Bgjurisdiction')
  },
  {
    path: '/Bgreviewone',
    name: 'Bgreviewone',
    component: () => import('../views/Backpage/Bgreviewone')
  },
  {
    path: '/Bgreviewtwo',
    name: 'Bgreviewtwo',
    component: () => import('../views/Backpage/Bgreviewtwo')
  },
  {
    path: '/Bgreview',
    name: 'Bgreview',
    component: () => import('../views/Backpage/Bgreview')
  },
  {
    path: '/Expert',
    name: 'Expert',
    component: () => import('../views/Backpage/Expert')
  },
  {
    path: '/Engineering',
    name: 'Engineering',
    component: () => import('../views/Backpage/Engineering')
  },
  {
    path: '/Bgmyproject',
    name: 'Bgmyproject',
    component: () => import('../views/Backpage/Bgmyproject')
  }, {
    path: '/tableList',
    name: 'tableList',
    component: () => import('../views/Declare/tableList.vue'),
    meta: { needLogin: true }
  },
  {
    path: "/Benefit",
    name: "Benefit",
    component: () => import('../views/Benefit.vue')
  },
  {
    path: '/Preview',
    name: 'Preview',
    component: () => import('../views/Declare/Preview')
  }, {
    path: '/MessageCenter',
    name: 'MessageCenter',
    component: () => import('../views/Declare/MessageCenter'),
    meta: { needLogin: true }
  }, {
    path: '/Personage',
    name: "Personage",
    component: () => import('../views/Declare/Personage.vue'),
    meta: { needLogin: true }
  },
  {
    path: '/Construction',
    name: 'Construction',
    component: () => import("../views/Index/Construction.vue")
  },

  {
    path: '/Report',
    name: 'Report',
    component: () => import('../views/Declare/Report'),
    meta: { needLogin: true }
  },
  // 附件
  {
    path: '/Attachment',
    name: 'Attachment',
    component: () => import('../views/Declare/Attachment'),
    meta: { needLogin: true }
  },
  {
    path: '/Specification',
    name: 'Specification',
    component: () => import('../views/Backpage/Specification')
  },
  {
    path: '/Specificationone',
    name: 'Specificationone',
    component: () => import('../views/Backpage/Specificationone')
  },
  {
    path: '/LibraryDel',
    name: 'LibraryDel',
    component: () => import('../views/LibraryDel')
  }, {
    path: "/Information",
    name: "Information",
    component: () => import('../views/Backpage/Information')
  },
  {
    path: "/ChangePassword",
    name: "ChangePassword",
    component: () => import('../views/changePassword')
  },
  {
    path: "/Message",
    name: "Message",
    component: () => import('../views/Backpage/Message')
  },
  {
    path: "/ExpertPim",
    name: "ExpertPim",
    component: () => import('../views/Backpage/ExpertPim')
  },
  {
    path: "/Temporary",
    name: "Temporary",
    component: () => import('../views/Backpage/Temporary')
  },
  {
    path: "/Switch",
    name: "Switch",
    component: () => import('../views/Backpage/Switch')
  },
  {
    path: "/Declaration",
    name: "Declaration",
    component: () => import('../views/Backpage/Declaration')
  },
  {
    path: "/Banner",
    name: "Banner",
    component: () => import('../views/Backpage/Banner')
  },
  {
    path: "/FriendshipLink",
    name: "FriendshipLink",
    component: () => import('../views/Backpage/FriendshipLink')
  },
  {
    path: "/Innovation",
    name: "Innovation",
    component: () => import('../views/Backpage/Innovation')
  },

]
const scrollBehavior = function (to) {
  if (to.hash) {
    return {
      // 通过 to.hash 的值來找到对应的元素
      selector: to.hash
    }
  }
}
const router = new VueRouter({
  routes,
  // mode:history,
  base: "/",
  scrollBehavior
})

// router.beforeEach((to,  next) => {
//   console.log('开始页面切换');
//   console.log(to.fullPath)
//   var tempId = Utils.getCookie('temp-id');
//   var userInfo = sessionStorage.getItem('ssm_u_info');
//   if(to.fullPath != '/login' && (tempId == null || tempId == '' || userInfo == null || userInfo == '')){
//     window.location.href = '/login';
//   }
//   next();
// });

export default router
